import MonitoringQueueEntryTableRow from './MonitoringQueueEntryTableRow';

export default MonitoringQueueEntryTableRow;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/row/index.js